import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Mock responses / error payloads can carry non-serializable bits; keep DX clean.
      serializableCheck: false,
    }),
  devTools: true,
});

export default store;
